import { theme } from '@sellpy/design-system-react-web'
import colorTheme from './color/theme.json'
import textTheme from './text/theme.js'
import generalTheme from './theme.json'

const mergedTheme = {
  color: colorTheme,
  text: textTheme,
  ...generalTheme,
  ...theme
}

/** @typedef {typeof mergedTheme} MergedTheme */

export default mergedTheme
